// TODO:
// - rename translation file to `boardwalkTransactions` -- `transactions`
// - fetchPayments, should go to generic URL - not boardwalk
// - handleMakePayment should be non-bwalk specific
import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import { createRentReceipt, boardwalkPayments } from 'actions/tenantProfileActions';
import PaymentReceiptsTable from './PaymentReceiptsTable';
import styled from 'styled-components';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import { BounceLoader } from 'halogenium';
import moment from 'moment';
import { DaysBetween } from 'helpers/DateHelper';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Select } from 'components/ui/Select';
import CtaPrimary from 'components/ui/CtaPrimary';

import { AccentColor } from 'helpers/AccentColorHelper';

const StyledSelect = styled(Select)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;
const StyledDatePickerAccessible = styled(DatePickerAccessible)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const StyledBalanceHeader = styled.div`
  background-color: ${props => (props.accentColor ? props.accentColor : colors.BLUE_DENIM)};
  padding: 24px 24px 20px;
  margin: 0 0 10px 0;
  position: relative;
`;

const StyledBalanceHeaderP = styled.p`
  color: #fff;
  text-align: center;
  margin-bottom: 5px;
`;

const StyledBalanceHeaderH1 = styled.h1`
  color: #fff;
  text-align: center;
  margin-top: 5px;
`;

const StyledButton = styled(CtaPrimary)`
  height: 40px;
  bottom: -40px;
  font-size: 12px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.15);
  padding-left: 30px;
  padding-right: 30px;
  color: ${props => (props.accentColor ? props.accentColor : colors.BLUE_DENIM)}
  background-color: #fff;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  display: block;
  position: absolute;
`;

class PaymentReceipts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: getTranslatedString('transactions.filter.all'),
      receiptDialogOpen: false,
      paymentDetails: {},
      subset: '1_month',
      rangeStartDate: moment()
        .subtract('months', 6)
        .toDate(),
      rangeEndDate: new Date(),
      startDateError: null,
      endDateError: null,
    };
  }

  subsets = [
    {
      value: '1_month',
      label: getTranslatedString('tenantPortal.boardwalkTransactions.subsets.oneMonth'),
    },
    {
      value: '3_months',
      label: getTranslatedString('tenantPortal.boardwalkTransactions.subsets.threeMonths'),
    },
    {
      value: '6_months',
      label: getTranslatedString('tenantPortal.boardwalkTransactions.subsets.sixMonths'),
    },
    {
      value: '12_months',
      label: getTranslatedString('tenantPortal.boardwalkTransactions.subsets.twelveMonths'),
    },
    {
      value: 'all',
      label: getTranslatedString('tenantPortal.boardwalkTransactions.subsets.all'),
    },
    {
      value: 'custom',
      label: getTranslatedString('tenantPortal.boardwalkTransactions.subsets.custom'),
    },
  ];

  toggleReceiptDialog = paymentDetails => {
    if (paymentDetails) {
      return this.setState({ receiptDialogOpen: true, paymentDetails });
    }

    this.setState({ receiptDialogOpen: false, paymentDetails: {} });
  };

  hasError = () => {
    const { rangeStartDate, rangeEndDate, subset } = this.state;
    if (subset !== 'custom') return false;

    let startDateError = null;
    let endDateError = null;
    if (!rangeStartDate || !moment(rangeStartDate).isValid) {
      startDateError = getTranslatedString(
        'tenantPortal.boardwalkTransactions.startDateError.present'
      );
    }
    if (!rangeEndDate || !moment(rangeEndDate).isValid) {
      endDateError = getTranslatedString('tenantPortal.boardwalkTransactions.endDateError.present');
    }

    if (!startDateError && !endDateError && DaysBetween(rangeStartDate, rangeEndDate) <= 0) {
      startDateError = getTranslatedString(
        'tenantPortal.boardwalkTransactions.startDateError.lessThan'
      );
    }
    this.setState({
      startDateError,
      endDateError,
    });

    if (!startDateError && !endDateError) {
      return false;
    } else {
      return true;
    }
  };

  fetchPayments = () => {
    const { subset, rangeStartDate, rangeEndDate } = this.state;

    if (!this.hasError()) {
      this.props.boardwalkPayments(subset, rangeStartDate, rangeEndDate);
    }
  };

  handleSubsetChange = e => {
    const newSubset = e.target.value;
    this.setState({ subset: newSubset }, () => {
      this.fetchPayments();
    });
  };

  handleStartDateChange = date => {
    this.setState({ rangeStartDate: date }, () => {
      this.fetchPayments();
    });
  };

  handleEndDateChange = date => {
    this.setState({ rangeEndDate: date }, () => {
      this.fetchPayments();
    });
  };

  handleMakePayment = () => {
    this.props.togglePayDialog();
    this.props.toggleDialog();
  };

  render() {
    const { paymentList, fullScreen, isOpen, toggleDialog } = this.props;
    return (
      <Dialog
        fullScreen={fullScreen}
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="show-previous-rents"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <StyledBalanceHeader onClick={this.handleMakePayment}>
          <StyledBalanceHeaderP accentColor={AccentColor()}>
            {getTranslatedString('transactions.accountBalance')}
          </StyledBalanceHeaderP>
          <StyledBalanceHeaderH1>{this.props.amountOwing}</StyledBalanceHeaderH1>
          {this.props.hasEnablePaymentModule && (
            <StyledButton accentColor={AccentColor()}>
              {getTranslatedString('transactions.makePayment')}
            </StyledButton>
          )}
        </StyledBalanceHeader>
        <DialogTitle id="show-previous-rents">
          <h3 style={{ margin: '10px 0 5px', textAlign: 'center' }}>
            {getTranslatedString('transactions.paymentHistory')}
            <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>.</b>
          </h3>
          <div>
            <div className="row">
              <div className="col-xs-12">
                <StyledSelect
                  options={this.subsets}
                  name="subset"
                  label={getTranslatedString('tenantPortal.boardwalkTransactions.dateRange')}
                  value={this.state.subset}
                  onChange={this.handleSubsetChange}
                />
              </div>
            </div>
            {this.state.subset === 'custom' && (
              <div className="row">
                <div className="col-sm-6">
                  <StyledDatePickerAccessible
                    input={{
                      value: this.state.rangeStartDate,
                      onChange: this.handleStartDateChange,
                    }}
                    meta={{
                      touched: true,
                      error: this.state.startDateError,
                    }}
                    label={getTranslatedString('tenantPortal.boardwalkTransactions.startDate')}
                    maxDate={new Date()}
                    showYearDropdown
                    showMonthDropdown
                  />
                </div>
                <div className="col-sm-6">
                  <StyledDatePickerAccessible
                    input={{
                      value: this.state.rangeEndDate,
                      onChange: this.handleEndDateChange,
                    }}
                    meta={{
                      touched: true,
                      error: this.state.endDateError,
                    }}
                    label={getTranslatedString('tenantPortal.boardwalkTransactions.endDate')}
                    maxDate={new Date()}
                    showYearDropdown
                    showMonthDropdown
                  />
                </div>
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogContent>
          <Fragment>
            <div className="row">
              {paymentList && paymentList.length > 0 ? (
                <PaymentReceiptsTable data={paymentList} toggleDialog={this.toggleReceiptDialog} />
              ) : (
                <p
                  style={{
                    textAlign: 'center',
                    marginTop: '30px',
                    width: '60px',
                    margin: 'auto',
                  }}
                >
                  <BounceLoader color={AccentColor()} />
                </p>
              )}
            </div>
          </Fragment>
        </DialogContent>
        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={toggleDialog}
            id="close-button"
            style={{ color: AccentColor(), textTransform: 'uppercase' }}
          >
            {getTranslatedString('close')}
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
}

PaymentReceipts = withMobileDialog()(
  connect(
    state => ({
      paymentList: state.tenantProfile.boardwalkPayments,
      landlordHasUploadedLogo: !!state.userTypes.landlordLogoUrl,
    }),
    { createRentReceipt, boardwalkPayments }
  )(PaymentReceipts)
);

export default PaymentReceipts;
